import type { JSX } from 'react';
import type { TextProps } from '@wistia/ui';
import { UIProvider, Text as WistiaText } from '@wistia/ui';

export const Text = ({ children, ...props }: TextProps): JSX.Element => {
  return (
    <UIProvider>
      <WistiaText {...props}>{children}</WistiaText>
    </UIProvider>
  );
};
